import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../Base/Auth/contexts/AuthContext';
import { navConfig } from './navConfig';
import styles from './Home.module.css';

export default function Home() {
  const { user, isAuthenticated } = useAuth();

  // Проверка прав (взята из Navbar)
  const hasPerm = perm => {
    const perms = user?.permissions || [];
    if (perms.includes(perm)) return true;
    const parts = perm.split(':');
    if (
      parts[0] === 'pages' &&
      parts.length === 4 &&
      parts[2] === 'view' &&
      perms.includes(`pages:${parts[1]}:view:any`)
    )
      return true;
    return false;
  };

  // Доступные интерфейсы (роли)
  const availableRoles = navConfig.filter(role => hasPerm(role.permission));

  return (
    <div className={styles.home}>
      <div className={styles.header}>
        <h1>
          Добро Пожаловать
          {isAuthenticated && user ? `, ${user.username}` : ''}!
        </h1>
        <p className={styles.subtitle}>
          {isAuthenticated
            ? 'Выберите интерфейс для работы:'
            : 'Войдите, чтобы увидеть доступные интерфейсы.'}
        </p>
      </div>

      {isAuthenticated ? (
        <div className={styles.rolesGrid}>
          {availableRoles.map(role => (
            <Link to={`/${role.key}`} key={role.key} className={styles.roleCard}>
              <div className={styles.iconWrapper}>
                <i className={`bi ${role.icon}`} />
              </div>
              <div className={styles.roleInfo}>
                <h3>{role.label}</h3>
                <p>Интерфейс {role.label.toLowerCase()}</p>
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <div className={styles.loginPrompt}>
          <Link to="/login" className={styles.loginButton}>
            <i className="bi bi-box-arrow-in-right" /> Войти
          </Link>
        </div>
      )}
    </div>
  );
}
